module.exports = __webpack_public_path__ + "img/03.1087ed62.png";